// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SIGNUP_PHONE_WE_SENT_YOU_NEW_ACTIVATION_CODE_CALL = "Vol\u00e1me ti znovu a nadiktujeme ti nov\u00fd aktiva\u010dn\u00ed k\u00f3d.";
export const SIGNUP_PHONE_WE_SENT_YOU_NEW_ACTIVATION_CODE_SMS = "Poslali jsme ti nov\u00fd aktiva\u010dn\u00ed k\u00f3d.";
export const YOU_HAVE_BEEN_SUCCESSFULLY_REGISTERED = "Byla jsi \u00fasp\u011b\u0161n\u011b zaregistrov\u00e1n\u00e1.";
export const YOU_WERE_SUCCESSFULLY_LOGGED_IN_AS_username = "Pr\u00e1v\u011b jsi se p\u0159ihl\u00e1sila jako u\u017eivatelka %(username)s.";
